// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"643f620a","513":"88d97bab","703":"06dec5c6"}[chunkId] + ".chunk.js";
};